module.exports = __webpack_public_path__ + "img/21_18.cfc0e0c8.png";